/* eslint-disable camelcase */
import { useState, useEffect } from 'react';
import { withFormik } from 'formik';
import { Col, Form, Row } from 'react-bootstrap';
import { Input } from 'components';
import { withStore } from 'store';
import { mapPropsToValues } from './config';
import styles from './styles.module.scss';
// import { CURRENT_GIFT_TABLE } from 'constants/storage64';
// import { useStorage64, useGiftTableInfo } from 'hooks';

const BaseInfo = ({
  type = { name: '' },
  plan = { name: '' },
  guest_range = {
    minimum: '',
    maximum: '',
  },
  celebrate_labels,
  eventTypes,
}) => {
  const [icon, setIcon] = useState('');

  // const [storageGiftTable] = useStorage64(CURRENT_GIFT_TABLE, {});
  // console.log('storageGiftTable en Base info',storageGiftTable);

  useEffect(() => {
    if (eventTypes) {
      const eventTypeIcon = eventTypes.find(
        (eventType) => eventType.id === type.id
      );

      setIcon((currentIcon) =>
        eventTypeIcon ? eventTypeIcon.image : currentIcon
      );
    }
  }, [eventTypes, type]);

  useEffect(() => {
    if (guest_range) {
      // console.log('range',guest_range);
    }
  }, [guest_range]);

  
  return (
      <section className={styles.baseInfo}>
        <h5 className={`my-5 mb-md-4 mt-0 text-center ${styles.titleData}`}>
          Los campos base del evento no podrán ser editados
        </h5>

        <Form>
          <Row>
            <Col xs={12} md={6}>
              <Input
                  className={styles.inputborder}
                  label="Tipo de Evento"
                  name="eventType"
                  value={type.name}
                  readonly
                  right={
                    icon && (
                        <img
                            src={icon}
                            alt={`${plan.name} icono`}
                            className={styles.eventTypeIcon}
                        />
                    )
                  }
              />
              <Input
                  className={styles.inputborder}
                  label="Tipo de Plan"
                  name="planType"
                  value={plan.name}
                  readonly
              />
              <Input
                  className={styles.inputborder}
                  label="Número de invitados"
                  value={`${guest_range.minimum} - ${guest_range.maximum}`}
                  name="guestNumber"
                  readonly
              />
              {celebrate_labels &&
              celebrate_labels.map(({ label }) => (
                  <Input
                      className={styles.inputborder}
                      key={label.id}
                      value={label.value}
                      label={label.name}
                      name={label.name}
                      readonly
                  />
              ))}
            </Col>
          </Row>
        </Form>
      </section>
  );
};

export default withStore({
  mapStateToProps: (state) => ({
    ...state.giftTable.giftTableInfo.data,
    eventTypes: state.catalogs.fullEventTypes || [],
  }),
})(
  withFormik({
    mapPropsToValues,
  })(BaseInfo)
);
